<div class="clearfix d-flex justify-content-center pt-4">
  <div>
    <h6 class="ms-5 ps-2 mb-2 fw-semibold" *ngIf="fileList?.length">Imagem atual</h6>

    <nz-upload class="d-flex w-auto"
      nzListType="picture-card"
      [nzBeforeUpload]="beforeUpload"
      [(nzFileList)]="fileList"
      [nzShowButton]="fileList.length < 8"
      [nzPreview]="handlePreview"
    >
      <div>
        <span nz-icon nzType="plus"></span>
        <div style="margin-top: 8px">Enviar Imagem</div>
      </div>
    </nz-upload>

    <nz-modal
      [nzVisible]="previewVisible"
      [nzContent]="modalContent"
      [nzFooter]="null"
      (nzOnCancel)="previewVisible = false"
    >
      <ng-template #modalContent>
        <img [src]="previewImage" [ngStyle]="{ width: '100%' }" />
      </ng-template>
    </nz-modal>
  </div>
</div>
